
import Vue from 'vue'
import CategoryPanel from '@/categories/components/CategoryPanel.vue'
import { CategoryType } from '@/types'

export default Vue.extend({
  components: {
    CategoryPanel
  },
  props: {
    categories: {
      type: Array as () => CategoryType[],
      required: true
    }
  }
})
